<script setup lang="ts">
	import {ref, computed, onMounted} from 'vue';
	import {injectEnv} from "@fd/Environment";
	import SymIcon from "@fd/helpers/SymIcon.vue";
	
	const props = defineProps({
		mailIdent: String,
		readOnly: Boolean,
		restApi: String
	});

	const env = injectEnv();
	const items = ref([]);
	const errorMessage = ref("");

	const apiUrl = computed(() => {
		return props.restApi+"?mailIdent="+props.mailIdent;
	});
	
	const titleRemoveAtt = computed(() => {
		return env.msg("title.deleteAttachment");
	});
	
	const isError = computed(() => {
		return errorMessage.value !== null && errorMessage.value !== undefined && errorMessage.value.length>0;
	});
	
	function loadAttachments() {
		return env.net.fetch(apiUrl.value)
			.then(response => response.json())
			.then(data => {
				console.log("Loaded attachments:"+JSON.stringify(data));
				items.value=data;
			})
			.catch((error) => {
				console.log("error refresh data:"+error);
				errorMessage.value = error;
			});
	}
	
	defineExpose({loadAttachments});
	
	function getContentItemApi(item) {
		return props.restApi+"/"+item.id+"/content?mailIdent="+props.mailIdent;
	}
	
	function getItemApi(item) {
		return props.restApi+"/"+item.id+"?mailIdent="+props.mailIdent;
	}
	
	function removeAttachment(toRemoveItem) {
		env.net.fetch(getItemApi(toRemoveItem), "DELETE")
		.then(response => {
			if (response.ok) {
				errorMessage.value="";
				let newItems = items.value.filter(item => item.id !== toRemoveItem.id);
				items.value=newItems;
			}
			else {
				console.error('Error:', response.status);
				errorMessage.value="RestApi point return status:"+response.status;
			}
		})
		.catch((error) => {
		  console.error('Error:', error);
		  errorMessage.value="Error at restApi point:"+error;
		});
	}
	
	onMounted(() => {
		loadAttachments();
	})
	
</script>
<template>
	<div class="attachment">
		<div v-if="isError" class="errors"><span class="perr">{{errorMessage}}</span></div>

		<div v-for="item in items" class="attDiv">
			<a v-if="!readOnly" class="fakeHref" :title="titleRemoveAtt" @click="removeAttachment(item);">
				<sym-icon name="cross-14"/>
			</a>
			<a :href="getContentItemApi(item)" target="_blank" :title="item.name" class="attName">{{item.name}}</a>
			<span class="att-size">{{item.size}}</span>
		</div>
	</div>
</template>

